/*
 * @Description: cookie方法
 * @Author: 王振
 * @Date: 2021-07-07 10:02:10
 * @LastEditors: 王振
 * @LastEditTime: 2021-07-07 16:45:53
 */
import Cookies from "js-cookie";

const TokenKey = "56lsh_pc_token"; //token
const UserKey = "56lsh_pc_user"; //用户信息

/**
 * 获取token
 */
export function getToken() {
  return Cookies.get(TokenKey);
}

/**
 * 设置token
 */
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

/**
 * 删除token
 */
export function removeToken() {
  return Cookies.remove(TokenKey);
}

/**
 * 设置用户个人信息
 */
export function setUser(params) {
  return Cookies.set(UserKey, params);
}

/**
 * 获取用户个人信息
 */
export function getUser() {
  return Cookies.getJSON(UserKey);
}

/**
 * 删除用户个人信息
 */
export function removeUser() {
  return Cookies.remove(UserKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js